export default __webpack_public_path__ + "static/media/right.5bf29da3.svg";